<template>
  <div class="logisticsRevise">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('logistics.logisticsView.logisticsViewOrder') }}
          </div>
        </template>
        <div class="collapse-content">
          <logistics-receipt
            v-bind:logisticsData="logisticsData"
            v-bind:canEdit="true"
            ref="logisticsData"
          ></logistics-receipt>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('logistics.logisticsView.baseInformation') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-information
            v-bind:upstreamType="this.$route.query.number"
            v-bind:baseData="baseData"
            :logisticsData="logisticsData"
            v-bind:canEdit="false"
            ref="baseDataInformation"
            @storageChange="storageChange"
          ></base-information>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('logistics.logisticsView.costFree') }}
          </div>
        </template>
        <div class="collapse-content">
          <cost-free
            v-bind:costData.sync="costData"
            v-bind:canEdit="true"
            ref="costData"
          ></cost-free>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="common-tab tab">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane :label="$t('logistics.logisticsView.priductRowList')" name="1">
          <div class="tabArea">
            <commodity-market
              :commodityMarketData="commodityMarketData"
              v-bind:upstreamType.sync="upstreamType"
              ref="commodityMarket"
            ></commodity-market>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('logistics.logisticsView.costView')" name="2">
          <div class="tabArea">
            <detailsof-Charges
              v-bind:detailsOfChargesData.sync="detailsOfChargesData"
              :costType="costType"
              ref="detailsOfCharges"
            ></detailsof-Charges>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('logistics.logisticsView.transportationInformation')" name="3">
          <div class="tabArea">
            <transportation-information
              v-bind:transportationInformationData.sync="transportationInformationData"
              :shippingMethod.sync="shippingMethod"
              ref="transportationInformation"
            ></transportation-information>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="fixed-bottom-btnList">
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        :disabled="logisticsData.inboundStatus != '02'"
        @click="save('03')"
        >{{ $t('logistics.logisticsView.pleaseGetUp') }}</el-button
      >
      <el-button class="fixed-bottom-btn" type="primary" @click="save('01')">{{
        $t('logistics.logisticsView.save')
      }}</el-button>
      <el-button class="fixed-bottom-btn" type="primary" @click="save('02', 'Y')">{{
        $t('logistics.logisticsView.submit')
      }}</el-button>
      <el-button class="fixed-bottom-btn" type="primary" @click="isEdit = true">{{
        $t('logistics.logisticsView.exportFiles')
      }}</el-button>
      <el-button
        style="width: 100px"
        type="primary"
        :disabled="['02'].includes(logisticsData.inboundStatus)"
        @click="deletDetail"
        >{{ $t('logistics.logisticsView.delete') }}</el-button
      >
    </div>
    <el-dialog :title="$t('logistics.logisticsView.copyFiles')" :visible.sync="isEdit">
      <upload
        ref="upload"
        @upload="uploadFile"
        v-bind:tableData="attachmentList"
        v-bind:isShow="canEdit"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="isEdit = false">{{ $t('logistics.logisticsView.close') }}</el-button>
        <el-button type="primary" @click="isEdit = false">{{
          $t('logistics.logisticsView.sure')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  import LogisticsReceipt from './components/logisticsReceipt';
  import BaseInformation from './components/baseInformation';
  import CostFree from './components/costFree';
  import upload from '@/components/upload';
  import CommodityMarket from './components/commodityMarket';
  import DetailsofCharges from './components/detailsOfCharges';
  import TransportationInformation from './components/transportationInformation';

  export default {
    name: 'logisticsRevise',
    components: {
      LogisticsReceipt,
      BaseInformation,
      CostFree,
      upload,
      CommodityMarket,
      DetailsofCharges,
      TransportationInformation,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      let newDate = new Date();
      return {
        canEdit: true,
        isEdit: false,
        load: false,
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开那些面板，
        //物流信息
        logisticsData: {
          inboundStatus: '', //状态
          inboundCreatePersonName: '',
          inboundCreatePersonNo: '',
          createDate: newDate, //创建日期
          inboundNo: '', //物流单号
          companyCode: '', //公司编号
          companyName: '', //公司名称
        },
        // 基本信息
        baseData: {
          partnerNo: '', //供应商编码
          partnerName: '', //供应商名称
          partnerNoList: { pickupStorageName: '', partnerCode: '' }, //供应商回显
          storageName: '', //仓库名称
          storageNo: '', //仓库代码
          inboundStorageName: '', //入库仓库（退换货）
          inboundStorageNo: '', //入库仓库代码（退换货）
          storageNoList: { deliverToStorageNo: '', deliverToStorageName: '' }, //仓库回显
          entrustingPartyName: '', //委托方名称
          entrustingPartyNo: '', //委托方代码
          entrustingPartyList: {
            deliverToStorageNo: '',
            deliverToStorageName: '',
          },
          // entrustingParty:[],
          marineBillOfLadingNo: '', //海运提单号
          nameLot: '', //船名/批次
          salesmanNo: '', //业务员编码
          salesmanName: '', //业务员名称
          returnSalesmanCode: '', //业务员编码（退换货）
          returnSalesmanName: '', //业务员名称（退换货）
          salesmanNoList: { salesmanNo: '', salesmanName: '' },
          inboundDepartmentNo: '', //部门编码
          instructionDepartmentName: '', //部门名称
          returnDepartmentCode: '', //部门编码（退换货）
          returnDepartmentName: '', //部门名称（退换货）
          inboundDate: newDate, //入库日期
          inboundType: '', //入库类型
          businessProperty: '', //业务性质
          avoidBoxDate: '', //免箱期至
          shippingMark: '', //备注
          externalNo: '', //外部编码
        },
        //费用
        costData: {
          totalExpense: '', //费用
          currencyTypeName: '', //币种
          currencyTypeCode: '',
          currencyCode: '', //币种code（退换货）
          currencyName: '', //币种名称（退换货）
          settleDate: '', //结算日期
          settlePersonName: '', //结算人员姓名
          settleNo: '', //结算单号
          settled: false, //标识
        },
        //商品行项目表格
        commodityMarketData: [],
        //费用详情表格
        detailsOfChargesData: [],
        //运输信息表格
        transportationInformationData: [],
        //附件
        attachmentList: [],
        costType: [], //费率类型
        shippingMethod: { shippingMethod: '' }, //运输方式
        activeName: '1',
        version: '', //版本号
        upstreamType: '', //来源
      };
    },
    mounted() {
      this.getDate();
      this.getCostType();
    },
    methods: {
      //收货仓库改变
      storageChange(val) {
        this.$refs.commodityMarket.getTableData().forEach((item) => {
          item.storageNo = val.storageNo;
          item.storageName = val.storageName;
        });
        this.commodityMarketData = this.$refs.commodityMarket.getTableData();
      },
      uploadFile(value) {
        this.attachmentList = value;
      },
      getTime(date) {
        let seperator1 = '-';
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
      },
      getDate() {
        this.upstreamType = this.$route.query.number;
        if (this.$route.query.inboundType) {
          this.baseData.inboundType = this.$route.query.inboundType;
        }
        if (this.$route.query.number == '1') {
          this.makeSupperInformation();
          // this.baseData.inboundType= this.$route.query.inboundType;
        } else if (this.$route.query.number == '3') {
          //整理点击退换货单进来的数据
          this.makeReturnInformation();
        } else if (this.$route.query.number == '4') {
          //整理点击拷贝库存调拨单进来的数据
          this.makeAllotNoInformation();
        }
      },
      //供应商查询
      makeSupperInformation() {
        let instructionNo = this.$route.query.instructionNo;
        let arr = ['logisticsData', 'baseData', 'costData'];
        this.loading.startLoading();
        this.$axios.get(API.GETSHIPPINGINSTRUCTION_DATA_API + instructionNo).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            for (let item of Object.keys(res.data.data)) {
              for (let objName of arr) {
                if (Object.keys(this[objName]).includes(item)) {
                  this[objName][item] = res.data.data[item];
                }
              }
            }
            //供应商按钮进来后，进本信息操作
            //部门
            this.baseData.entrustingPartyList = {
              deliverToStorageNo: res.data.data.entrustingPartyNo,
              deliverToStorageName: res.data.data.entrustingPartyName,
            };
            this.baseData.storageNoList = {
              deliverToStorageNo: res.data.data.deliverToStorageNo,
              deliverToStorageName: res.data.data.deliverToStorageName,
            };
            this.baseData.partnerNoList = {
              partnerCode: res.data.data.partnerNo,
              pickupStorageName: res.data.data.partnerName,
            };
            this.baseData.salesmanNoList = {
              salesmanNo: res.data.data.salesmanNo,
              salesmanName: res.data.data.salesmanName,
            };
            this.baseData.marineBillOfLadingNo = res.data.data.marineLadingNo;
            //收货仓库
            this.baseData.storageNo = res.data.data.deliverToStorageNo;
            this.baseData.storageName = res.data.data.deliverToStorageName;

            this.baseData.partnerNo = res.data.data.partnerNo;
            this.baseData.entrustingPartyNo = res.data.data.deliverToStorageNo;
            //直拨非直拨
            this.baseData.directDeliver = res.data.data.directDeliver;
            //部门
            this.baseData.inboundDepartmentNo = res.data.data.instructionDepartmentNo;
            this.baseData.inboundDepartmentName = res.data.data.instructionDepartmentName;
            //整理物流入库单信息
            this.logisticsData.inboundCreatePersonName = this.userInfo.userInfo.userName;
            this.logisticsData.inboundCreatePersonNo = this.userInfo.userInfo.userCode;
            this.logisticsData.companyName = this.userInfo.userInfo.companyName;
            this.logisticsData.companyCode = this.userInfo.userInfo.companyCode;
            // this.logisticsData.inboundStatus = res.data.data.instructionStatus;
            if (res.data.data.settled == 1) {
              this.costData.settled = true;
            } else {
              this.costData.settled = false;
            }
            //整理商品行项目
            this.commodityMarketData = res.data.data.storageInstructionDetails;
            this.commodityMarketData.forEach((item) => {
              item.partnerCode = this.baseData.partnerCode;
              item.partnerName = this.baseData.partnerName;
              if (item.instructionNo) item.preNo = item.instructionNo;
              if (item.instructionDetailNo) item.preDetailNo = item.instructionDetailNo;
              //剩余应入=-100，那么带入物流入库数应该是0
              item.inboundQuantity =
                Number(item.inboundNumLogisticsRemaining) < 0
                  ? 0
                  : item.inboundNumLogisticsRemaining;
              item.inboundNumLogisticsRemaining =
                Number(item.inboundNumLogisticsRemaining) < 0
                  ? 0
                  : item.inboundNumLogisticsRemaining;
              item.productName = item.productDesc;
              // 1000726 非直拨情况下，供应商发货指令中的物流批次号自动带到物流入库单中（可见，可修改）
              // item.distributionBatchNo =item.existInboundFlag=='0'?this.baseData.shippingMark:item.distributionBatchNoExist;//当前批次号（物流批次）
              // item.distributionBatchNo = this.baseData.shippingMark
              item.inboundUnit = item.unit;
              item.storageNo = this.baseData.storageNo;
              item.storageName = this.baseData.storageName;
              if (item.purchaseContractDetailNo) {
                item.puchaseDetailNo = item.purchaseContractDetailNo;
              } else {
                item.puchaseDetailNo = item.purchaseIntentDetailNo;
              }
              item.purchaseNo = item.purchaseContractNo;
              item.productMark = item.mark;
              if (item.returnNo) item.preNo = item.returnNo;
            });
            this.baseData.purchaseContractNo = this.commodityMarketData[0].purchaseNo;
            //指令数量小于0不能展示
            this.commodityMarketData = this.commodityMarketData.filter((item) => {
              return Number(item.instructionNumber) > 0;
            });
            //运输信息整理
            this.transportationInformationData = res.data.data.storageInstructionTransports;
            this.transportationInformationData.forEach((item) => {
              item.shippingInfo = item.freightInformation;
              item.chargePerson = item.contactPerson;
              item.contactInfo = item.contactPhoneNo;
            });
            //运输方式
            this.shippingMethod.shippingMethod = res.data.data.distributionMode;
            this.attachmentList = res.data.data.storageAttachments;
            this.version = res.data.data.version;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //退换货查询
      makeReturnInformation() {
        let params = {
          returnType: this.$route.query.returnType,
          returnNo: this.$route.query.returnNo,
        };
        let arr = ['logisticsData', 'baseData', 'costData'];
        this.loading.startLoading();
        this.$axios.get(API.GET_ORDER_SALES_RETURN, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            for (let item of Object.keys(res.data.data)) {
              for (let objName of arr) {
                if (Object.keys(this[objName]).includes(item)) {
                  this[objName][item] = res.data.data[item];
                }
              }
            }
            //供应商按钮进来后，进本信息操作
            //委托方
            // this.baseData.entrustingPartyList = {
            //   deliverToStorageNo: res.data.data.entrustingPartyNo,
            //   deliverToStorageName: res.data.data.entrustingPartyName
            // };
            //仓库
            this.baseData.storageNoList = {
              deliverToStorageNo: res.data.data.inboundStorageNo,
              deliverToStorageName: res.data.data.inboundStorageName,
            };
            this.baseData.storageNo = this.baseData.inboundStorageNo;
            this.baseData.storageName = this.baseData.inboundStorageName;
            // //供应商
            // this.baseData.partnerNoList = {
            //   partnerCode: res.data.data.partnerNo,
            //   pickupStorageName: res.data.data.partnerName
            // };
            //业务员
            this.baseData.salesmanNoList = {
              salesmanNo: res.data.data.returnSalesmanCode,
              salesmanName: res.data.data.returnSalesmanName,
            };
            this.baseData.salesmanNo = this.baseData.returnSalesmanCode;
            this.baseData.salesmanName = this.baseData.returnSalesmanName;
            //部门
            this.baseData.inboundDepartmentNo = this.baseData.returnDepartmentCode;
            this.baseData.inboundDepartmentName = this.baseData.returnDepartmentName;
            //整理费用
            this.costData.currencyTypeName = this.costData.currencyName;
            this.costData.currencyTypeCode = this.costData.currencyCode;
            //整理物流入库单信息
            this.logisticsData.inboundCreatePersonName = this.userInfo.userInfo.userName;
            this.logisticsData.inboundCreatePersonNo = this.userInfo.userInfo.userCode;
            this.logisticsData.companyName = res.data.data.companyName;
            this.logisticsData.companyCode = res.data.data.companyCode;
            //状态问题需要解决
            // this.logisticsData.inboundStatus = res.data.data.instructionStatus;

            if (res.data.data.settled == 1) {
              this.costData.settled = true;
            } else {
              this.costData.settled = false;
            }
            //整理商品行项目)
            this.commodityMarketData = res.data.data.orderSalesReturnDetails;
            this.commodityMarketData.forEach((item) => {
              item.preNo = item.returnNo; //退货单号
              item.preDetailNo = item.returnDetailNo; //退货单行号
              item.productName = item.productDesc; //商品描述
              item.inboundUnit = item.unit; //单位
              item.inboundQuantity =
                Number(item.inboundNumLogisticsRemaining) < 0
                  ? 0
                  : item.inboundNumLogisticsRemaining;
              item.instructionNumber = item.returnQuantity;
              item.storageNo = this.baseData.storageNo;
              item.storageName = this.baseData.storageName;
              item.distributionBatchNo = null; //当前批次号（物流批次）
            });
            //指令数量小于0不能展示
            this.commodityMarketData = this.commodityMarketData.filter((item) => {
              return Number(item.instructionNumber) > 0;
            });
            //运输信息整理
            // this.transportationInformationData = res.data.data.storageInstructionTransports;
            // this.transportationInformationData.forEach(item => {
            //   item.shippingInfo = item.freightInformation;
            //   item.chargePerson = item.contactPerson;
            //   item.contactInfo = item.contactPhoneNo;
            // });
            //运输方式
            this.shippingMethod.shippingMethod = res.data.data.deliveryMethod;
            this.attachmentList = res.data.data.attachments;
            this.version = res.data.data.version;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //调拨单查询
      makeAllotNoInformation() {
        let params = {
          allotNo: this.$route.query.allotNo,
        };
        let arr = ['logisticsData', 'baseData', 'costData'];
        this.loading.startLoading();
        this.$axios.get(API.QUERY_DETAIL_BY_ALLOTNO, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            for (let item of Object.keys(res.data.data)) {
              for (let objName of arr) {
                if (Object.keys(this[objName]).includes(item)) {
                  this[objName][item] = res.data.data[item];
                }
              }
            }
            //供应商按钮进来后，进本信息操作
            //仓库
            this.baseData.storageNoList = {
              deliverToStorageNo: res.data.data.allotInStorageNo,
              deliverToStorageName: res.data.data.allotInStorage,
            };
            this.baseData.storageNo = res.data.data.allotInStorageNo;
            this.baseData.storageName = res.data.data.allotInStorage;
            //业务员
            this.baseData.salesmanNoList = {
              salesmanNo: res.data.data.salesmanNo,
              salesmanName: res.data.data.salesmanName,
            };
            //部门
            this.baseData.inboundDepartmentNo = res.data.data.allotDepartmentNo;
            this.baseData.inboundDepartmentName = res.data.data.allotDepartmentName;
            //船名批次
            this.baseData.nameLot = res.data.data.nameVoyageLicense;
            //备注
            // this.baseData.shippingMark = res.data.data.allotMark;
            this.baseData.shippingMark = res.data.data.shippingMark;

            //整理物流入库单信息
            this.logisticsData.inboundCreatePersonName = this.userInfo.userInfo.userName;
            this.logisticsData.inboundCreatePersonNo = this.userInfo.userInfo.userCode;
            this.logisticsData.companyName = this.userInfo.userInfo.companyName;
            this.logisticsData.companyCode = this.userInfo.userInfo.companyCode;
            //币种结算标识
            if (res.data.data.settled == 1) {
              this.costData.settled = true;
            } else {
              this.costData.settled = false;
            }
            //整理商品行项目
            this.commodityMarketData = res.data.data.storageAllotDetailVOs;
            this.commodityMarketData.forEach((item) => {
              if (item.allotNo) item.preNo = item.allotNo; //调拨单号
              if (item.allotDetailNo) item.preDetailNo = item.allotDetailNo; //行号
              item.productNo = item.productDetailNo; //商品编码
              // item.distributionBatchNo = item.preAllotBatchNo;//当前批次号（物流批次）
              item.distributionBatchNo = null; //当前批次号（物流批次）
              // item.inboundQuantity = item.confirmAllotInAmount;//物流入库数量（确认调出数量）
              item.inboundUnit = item.allotUnit; //单位
              item.unitNumber = item.confirmAllotInPackage; //件数（确认调入件数）
              if (item.returnDetailNo) item.preNo = item.returnDetailNo; //退货单号
              // item.inboundQuantity = item.actualInboundQuantity;//入库数量
              item.instructionNumber = item.allotOutAmount; //业务通知数量(业务调出数量)
              item.inboundQuantity =
                Number(item.inboundNumLogisticsRemaining) < 0
                  ? 0
                  : item.inboundNumLogisticsRemaining;
              item.storageNo = this.baseData.storageNo;
              item.storageName = this.baseData.storageName;
            });
            //指令数量小于0不能展示
            this.commodityMarketData = this.commodityMarketData.filter((item) => {
              return Number(item.instructionNumber) > 0;
            });
            // 运输信息整理
            this.transportationInformationData = res.data.data.distributionAllotTransportVOs;
            this.transportationInformationData.forEach((item) => {
              item.shippingInfo = item.freightInformation;
              item.chargePerson = item.contactPerson;
              item.contactInfo = item.contactPhoneNo;
            });
            //运输方式
            this.shippingMethod.shippingMethod = res.data.data.deliveryMethod;
            this.attachmentList = res.data.data.attachments;
            this.version = res.data.data.version;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 保存,撤销,提交
      save(val, submitCheck = 'Y') {
        //保存，撤销不需要校验
        if (val == '02') {
          let value = this.$refs.baseDataInformation.getVal();
          if (value != false) {
            Promise.resolve(this.$refs.detailsOfCharges.fullValidEvent()).then((r) => {
              if (r) {
                Promise.resolve(this.$refs.commodityMarket.fullValidEvent()).then((flag) => {
                  if (flag) {
                    const data = flag.commodityMarketData;
                    let inboundQuantityFlag = true;
                    data.forEach((item) => {
                      if (Number(item.inboundQuantity) < 0) {
                        inboundQuantityFlag = false;
                      }
                    });
                    if (inboundQuantityFlag) {
                      this.saveIng(val, submitCheck);
                    } else {
                      //剩余可以小于零，如果是负数不能带入入库数量，且提交要校验入库数量不能负数
                      this.$message({
                        showClose: true,
                        message: this.$t('logistics.logisticsView.inboundQuantityNegativeNum'),
                        type: 'error',
                      });
                    }
                  } else {
                    this.$message({
                      showClose: true,
                      message: this.$t('logistics.logisticsView.pleaseAddProudectRow'),
                      type: 'error',
                    });
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('logistics.logisticsView.pleaseAddCostRow'),
                  type: 'error',
                });
              }
            });
          }
        } else {
          this.saveIng(val);
        }
      },
      saveIng(val, submitCheck = 'Y') {
        let logisticsData = this.$refs.logisticsData.getSaveVal();
        let costData = this.$refs.costData.getSaveVal();
        this.$delete(costData, 'settled'); //删除标识属性
        let baseData = this.$refs.baseDataInformation.getSaveVal();
        let commodityMarketData = this.$refs.commodityMarket.getSaveVal();
        let detailsOfChargesData = this.$refs.detailsOfCharges.getSaveVal().detailsOfChargesData;
        let transportationInformation = this.$refs.transportationInformation.getSaveVal();
        let params = Object.assign({}, logisticsData, baseData, costData);
        if (typeof baseData.entrustingParty == 'object') {
          params.entrustingPartyNo = baseData.entrustingParty[0].partnerCode;
          params.entrustingPartyName = baseData.entrustingParty[0].partnerZhName;
        }
        if (typeof baseData.partnerNo == 'object') {
          params.partnerNo = baseData.partnerNo[0].partnerCode;
          params.partnerName = baseData.partnerNo[0].partnerZhName;
        }
        if (typeof baseData.storageNo == 'object') {
          params.storageNo = baseData.storageNo[0].storageCode;
          params.storageName = baseData.storageNo[0].storageName;
        }
        if (typeof baseData.salesmanNo == 'object' && baseData.salesmanNo != null) {
          params.salesmanNo = baseData.salesmanNo[0].personNo;
          params.salesmanName = baseData.salesmanNo[0].personName;
        }
        if (String(this.logisticsData.createDate).indexOf('中国标准时间') != -1) {
          params.createDate = this.getTime(this.logisticsData.createDate);
        }
        params.version = this.version;
        params.upstreamType = this.$route.query.number; //三种指令，传死值
        params.shippingInstructionNo = this.$route.query.instructionNo;
        params.distributionAttachments = this.attachmentList;
        params.distributionInboundProducts = commodityMarketData;
        params.distributionInboundExpenses = detailsOfChargesData;
        params.distributionInboundShippings =
          transportationInformation.transportationInformationData;
        params.shippingMethod = transportationInformation.shippingMethod.shippingMethod;
        params.departmentCode = this.userInfo.userInfo.departmentCode;
        params.departmentName = this.userInfo.userInfo.departmentName;
        this.loading.startLoading();
        let url = API.SAVADISTRIBUTIONINBOUND_DATA_API;
        if (val == '01') {
          url = API.SAVADISTRIBUTIONINBOUND_DATA_API;
        } else if (val == '02') {
          url = API.SUBMIT_DISTRIBUTIONINBOUND_DATA_API;
          params.submitCheck = submitCheck;
        } else if (val == '03') {
          url = API.UNDO_DISTRIBUTIONINBOUND_DATA_API;
        }
        this.$axios.post(url, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            let inboundNo = res.data.data.inboundNo;
            if (val == '03') {
              this.getDateView(inboundNo);
            } else if (val == '01') {
              if (this.$route.name == 'logisticsRevise') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getDateView(res.data.data.inboundNo);
              }
            } else {
              this.toList();
            }
          } else if (res.data.code == 9) {
            // 提交时校验软提示
            this.$confirmAction('提示', res.data.msg)
              .then(() => {
                this.saveIng(val, 'N');
              })
              .catch(() => {
                if (this.$route.name == 'logisticsRevise') {
                  this.dblclickEvent(res.data.data);
                }
              });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/logistics/logisticsRevise',
            name: 'logisticsRevise',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsRevise.logisticsRevise'),
            },
          },
          toPath: {
            path: '/logistics/logisticsView',
            name: 'logisticsView',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsReceiptList.logisticsView'),
            },
            query: {
              inboundNo: value.inboundNo,
              shippingInstructionNo: value.shippingInstructionNo,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //删除
      deletDetail() {},
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/logistics/logisticsRevise',
            name: 'logisticsRevise',
            meta: {
              keepAlive: true,
              title: this.$t('logistics.logisticsRevise.logisticsRevise'),
            },
          },
          toPath: {
            path: '/logistics/logisticsReceiptList',
            name: 'logisticsReceiptList',
            meta: {
              keepAlive: false,
              title: this.$t('logistics.logisticsView.logisticsReceiptList'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      //获取费用类型
      async getCostType() {
        let params = {
          dictType: 'logistics_expense_type',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.costType = selectStatus.data.data;
        }
      },
      //保存回显(返回列表的话就不用了)
      getDateView(inboundNo) {
        let arr = ['logisticsData', 'baseData', 'costData'];
        let params = {
          inboundNo: inboundNo,
          shippingInstructionNo: '',
        };
        this.loading.startLoading();
        this.$axios.get(API.GETDISTRIBUTIONINBOUND_DATA_API, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            for (let item of Object.keys(res.data.data)) {
              for (let objName of arr) {
                if (Object.keys(this[objName]).includes(item)) {
                  this[objName][item] = res.data.data[item];
                }
              }
            }
            //供应商按钮进来后，基本信息操作
            this.baseData.entrustingPartyList = {
              deliverToStorageNo: res.data.data.entrustingPartyNo,
              deliverToStorageName: res.data.data.entrustingPartyName,
            };
            this.baseData.storageNoList = {
              deliverToStorageNo: res.data.data.storageNo,
              deliverToStorageName: res.data.data.storageName,
            };
            this.baseData.partnerNoList = {
              partnerCode: res.data.data.partnerNo,
              pickupStorageName: res.data.data.partnerName,
            };
            this.baseData.salesmanNoList = {
              salesmanNo: res.data.data.salesmanNo,
              salesmanName: res.data.data.salesmanName,
            };
            this.baseData.marineBillOfLadingNo = res.data.data.marineBillOfLadingNo;
            this.baseData.storageNo = res.data.data.storageNo;
            this.baseData.partnerNo = res.data.data.partnerCode;
            this.baseData.entrustingPartyNo = res.data.data.deliverToStorageNo;
            this.logisticsData.inboundCreatePersonName = res.data.data.inboundCreatePersonName;
            this.logisticsData.inboundCreatePersonNo = res.data.data.inboundCreatePersonNo;
            this.logisticsData.companyName = res.data.data.companyName;
            this.logisticsData.companyCode = res.data.data.companyCode;
            if (res.data.data.settled == 0) {
              this.costData.settled = false;
            } else {
              this.costData.settled = true;
            }
            this.commodityMarketData = res.data.data.distributionInboundProducts;
            this.transportationInformationData = res.data.data.distributionInboundShippings;
            this.detailsOfChargesData = res.data.data.distributionInboundExpenses;
            this.distributionAttachment = res.data.data.distributionAttachments;
            //运输方式
            this.shippingMethod.shippingMethod = res.data.data.shippingMethod;
            this.instructionNo = res.data.data.instructionNo;
            this.version = res.data.data.version;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .logisticsRevise .tab {
    margin-top: 10px;
    margin-bottom: 90px;
  }
  .logisticsRevise .bottomBtn {
    text-align: center;
    padding: 20px;
  }
  .logisticsRevise .bottomBtn .saveBtn {
    width: 100px;
  }
  .logisticsRevise .collapse-main-content {
    padding-bottom: 0px !important;
  }
  .logisticsRevise .tabArea {
    box-sizing: border-box;
    padding: 20px;
    padding-top: 10px;
  }
</style>
